import { RootState } from '../configureStore';
import { ApplicationContract } from '../../contracts/application';

export const selectApplications = (state: RootState): ApplicationContract[] => {
    const apps = state.Applications.applications;
    return apps.ids.map(id => apps.byId[id]);
};

export const selectApplicationById = (state: RootState, id: string): ApplicationContract | undefined => {
    return state.Applications.applications.byId[id];
};

export const selectScopes = (state: RootState) => {
    return state.Applications.scopes;
};

export const selectEnvironment = (state: RootState) => {
    return state.Applications.environment;
};

export const selectLoading = (state: RootState) => {
    return state.Applications.loading;
};

export const selectError = (state: RootState) => {
    return state.Applications.error;
};

export const selectCredentialsBeingCreated = (state: RootState) => {
    return state.Applications.credentialsBeingCreated;
};

export const hasApplications = (state: RootState) => {
    return state.Applications.applications.ids.length > 0;
};
